import { useState } from 'react'

import useRedux from '../../../hooks/useRedux'
import useTranslations from '../../../hooks/useTranslations'
import { setSelected } from '../../../redux/catalogueManagement/action'
import ANTDButton from '../../../shared/antd/ANTDButton'
import ANTDCheckbox from '../../../shared/antd/ANTDCheckbox'
import { noImage } from '../../../utils/icons'
import { isEqual } from '../../../utils/javascript'
import { initialCatalogueSelect } from '../../catalogueManagement/catalogue.description'

const equipmentTable = ({ handleSelectChange, selectedEquipment }) => {
  const { t } = useTranslations()
  const { dispatch } = useRedux()
  const [formModel, setFormModel] = useState(false)
  const [editData, setEditData] = useState(null)

  const onFormModelToggle = () => {
    setFormModel(!formModel)
    if (formModel) {
      dispatch(setSelected(initialCatalogueSelect))
      setEditData(null)
    }
  }

  const handleEdit = data => {
    const { brandInfo, productSeriesInfo, modelInfo } = data || {}
    dispatch(
      setSelected({
        brandId: brandInfo?.id,
        productSeriesId: productSeriesInfo?.id,
        modelId: modelInfo?.id,
        unitType: productSeriesInfo?.unitType,
        selected: {
          brand: { label: brandInfo?.name, value: brandInfo?.id },
          productSeries: {
            label: productSeriesInfo?.name,
            value: productSeriesInfo?.id,
          },
          model: { label: modelInfo?.name, value: modelInfo?.id },
        },
      }),
    )
    setEditData(data)
    setFormModel(true)
  }

  const actionButtons = rowData => (
    <div className="flex-nowrap d-flex">
      {/* <ANTDButton className="bg-view" onClick={() => handleView(rowData)}>
        {t('btn_View')}
      </ANTDButton> */}
      <ANTDButton className="bg-edit" onClick={() => handleEdit(rowData)}>
        {t('btn_Edit')}
      </ANTDButton>
    </div>
  )

  const columns = [
    {
      title: null,
      key: 'select',
      render: rowData => {
        return (
          <ANTDCheckbox
            value={rowData}
            onChange={handleSelectChange}
            checked={selectedEquipment?.find(v =>
              isEqual(v?.equipmentId, rowData?.equipmentId),
            )}
          />
        )
      },
      hidden: !handleSelectChange,
    },
    {
      title: t('user_ID'),
      dataIndex: 'equipmentId',
      key: 'user_ID',
    },
    {
      title: t('user_Image'),
      dataIndex: ['imageDetails', 'fileUrl'],
      className: 'img-td',
      key: 'user_Image',
      render: rowData => {
        return (
          <div className="small-img-wrap">
            <img src={rowData || noImage} alt={'equipment_image'} />
          </div>
        )
      },
    },
    {
      title: t('job_Location'),
      key: 'job_Location',
      dataIndex: 'location',
    },
    {
      title: t('txt_Brand'),
      key: 'txt_Brand',
      dataIndex: ['brandInfo', 'name'],
    },
    {
      title: t('txt_ProductSeries'),
      key: 'txt_ProductSeries',
      dataIndex: ['productSeriesInfo', 'name'],
    },
    {
      title: t('job_UnitType'),
      key: 'job_UnitType',
      dataIndex: ['productSeriesInfo', 'unitType'],
    },
    {
      title: t('txt_Model'),
      key: 'txt_Model',
      dataIndex: ['modelInfo', 'name'],
    },
    {
      title: t('job_Category'),
      key: 'job_Category',
      dataIndex: 'category',
    },
    {
      title: t('job_EquipmentSerialNumber'),
      key: 'job_EquipmentSerialNumber',
      dataIndex: ['einInfo', 'name'],
    },
    {
      title: t('txt_Action'),
      key: 'txt_Action',
      render: rowData => {
        return <>{actionButtons(rowData)}</>
      },
    },
  ]

  return { t, columns, formModel, editData, onFormModelToggle }
}

export default equipmentTable
